<template>
  <div>
    <QueryFrame
      :count="count"
      :current="page"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
>
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType !== 2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>供应商名称:</label>
            <SupplierListSelect v-model="query.supplierId"></SupplierListSelect>
          </div>
          <div class="queryItem">
            <label>付款时间:</label>
            <timeStampDatePicker
              class="item"
              placeholder=" 请选择"
              clearable
              type="daterange"
              v-model.trim="query.payTime">
            </timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button type='primary' @click='handleShowAdd' v-if='handlePermission("prePaymentAdd")'>+ 新建预付</lk-button>
           <DownloadButton  @on-click="handleExport" v-if="handlePermission('prepaymentExcel')"></DownloadButton>

        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>

    <!-- 新建预付款 开始 -->
    <lk-modal
      v-model="modal.visiable"
      :mask-closable="false"
      title="新建预付款"
      @on-cancel="cancelModal"
    >
      <lk-form
        label-position="right"
        :label-width="150"
        :rules="formRules"
        :model="formModel"
        ref="form"
      >
        <div class="modalContainer">
          <lk-row :gutter="16">
            <lk-col :span="20">
              <lk-form-item label="供应商名称:" prop="supplierStoreId">
                <SupplierListSelect :status="1" v-model="formModel.supplierStoreId" @on-change="handleSupplierChange"></SupplierListSelect>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter="16">
            <lk-col :span="20">
              <lk-form-item label="预付金额:" prop="amount">
                <dtp-input-number
                  style="width: 100%"
                  :min="0.01"
                  :max="9999999999.99"
                  :precision="2"
                  :active-change="false"
                  v-model="formModel.amount">
                </dtp-input-number>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter="16">
            <lk-col :span="20">
              <lk-form-item label="付款时间:" prop="payTime">
                <timeStampDatePicker
                  class="item"
                  placeholder=" 请选择"
                  clearable
                  v-model.trim="formModel.payTime">
                </timeStampDatePicker>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter="16">
            <lk-col :span="20">
              <lk-form-item label="开票时间:" prop="invoiceTime">
                <timeStampDatePicker
                  class="item"
                  placeholder=" 请选择"
                  clearable
                  v-model.trim="formModel.invoiceTime">
                </timeStampDatePicker>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter="16">
            <lk-col :span="20">
              <lk-form-item label="发票编码:" prop="invoiceCode">
                <lk-input
                  class="item"
                  clearable
                  placeholder=""
                  v-model.trim="formModel.invoiceCode"
                  :maxlength="500">
                </lk-input>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </div>
      </lk-form>
      <div slot="footer">
        <div>
          <lk-button @click="cancelModal">取消</lk-button>
          <lk-button type="primary" @click="handleDoPrePaymentAdd" :loading="modal.loading">确定</lk-button>

        </div>
      </div>
    </lk-modal>
    <!-- 新建预付款 结束 -->
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import finance from '../../services/finance';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import DtpInputNumber from '../../components/DtpInputNumber';
import SupplierListSelect from '../../components/SupplierListSelect.vue';
import DownloadButton from '../../components/download/DownloadButton';

export default {
  name: 'prePayment',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DtpInputNumber,
    SupplierListSelect,
    DownloadButton,
  },
  computed: {},
  data() {
    return {
      query: {
        storeIdList: [], // 门店名称
        supplierId: null, // 供应商id
        payTime: null, // 付款时间
      },
      modal: {
        visiable: false,
        loading: false,
      },
      formModel: {
        supplierStoreId: null,
        supplierName: null,
        amount: null,
        payTime: null,
        invoiceTime: null,
        invoiceCode: null,
      },
      formRules: {
        supplierStoreId: [
          {
            required: true,
            message: '请选择供应商',
          },
        ],
        amount: [
          {
            required: true,
            message: '请输入预付金额',
          },
        ],
        payTime: [
          {
            required: true,
            message: '请选择付款时间',
          },
        ],
      },
      columns: [
        { title: '预付ID', key: 'id', minWidth: 116 },
        { title: '供应商名称', key: 'supplierName', minWidth: 116 },
        { title: '预付金额（元）', key: 'amount', minWidth: 116 },
        { title: '采购扣除（元）', key: 'finishPayAmount', minWidth: 116 },
        { title: '应付占用（元）', key: 'occupyPayAmount', minWidth: 116 },
        { title: '可用预付（元）', key: 'availablePrepaymentAmount', minWidth: 116 },
        { title: '付款时间', key: 'payTime', minWidth: 116 },
        { title: '开票时间', key: 'invoiceTime', minWidth: 116 },
        { title: '发票编码', key: 'invoiceCode', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            this.handlePermission('prePaymentInfo') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'prePaymentInfo', params: { id: row.id } });
                },
              },
            }, '查看') : null,
            this.handlePermission('prePaymentEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'prePaymentEdit', params: { id: row.id } });
                },
              },
            }, '编辑') : null,
          ]),
        },
      ],
      tableData: [],
    };
  },

  methods: {
    handleExport() { // 预留对接
      const params = utils.deepClone(this.params);
      if (params.payTime && params.payTime.length === 2) {
        params.payTimeStart = params.payTime[0];
        params.payTimeEnd = params.payTime[1];
        delete params.payTime;
      }
      delete params.page;
      delete params.size;

      params.queryCondition = utils.getQueryCondition('.queryContainer');
      finance.downloadFinancePrepaymentList(params).then((res) => {
        if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleSupplierChange(value, item) {
      this.formModel.supplierName = item.label;
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.payTime && this.params.payTime.length === 2) {
        this.params.payTimeStart = this.params.payTime[0];
        this.params.payTimeEnd = this.params.payTime[1];
        delete this.params.payTime;
      }
      this.tableData = [];
      finance.getPrePaymentList(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.count = count;
          list.forEach((item) => {
            const result = Object.assign(item, item.financePrepayment);
            delete result.financePrepayment;
            result.payTime = utils.formatDate(result.payTime);
            result.invoiceTime = utils.formatDate(result.invoiceTime);
            result.createTime = utils.formatDate(result.createTime);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {};
    },
    handleShowAdd() {
      this.modal.visiable = true;
    },
    // 预付款新建
    handleDoPrePaymentAdd() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$store.commit('setDisableLoading', true);
          this.modal.loading = true;
          const params = {
            financePrepayment: this.formModel,
          };
          finance.prePaymentAdd(params).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('新建成功');
              this.getData(true);
            } else {
              this.$Message.error(res.data.error);
            }
            this.modal.loading = false;
            this.modal.visiable = false;
          }).catch((err) => {
            this.modal.loading = false;
            this.modal.visiable = false;
            utils.handleError(err);
          });
        } else {
          this.$Message.error(' 请按照要求填写');
        }
      });
    },
    cancelModal() {
      this.$refs.form.resetFields();
      this.modal.visiable = false;
    },
  },
  created() {
    this.handleSearch(true);
    if (this.roleType !== 2) {
      this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
  },
};
</script>
<style lang="less" scoped>
.btns{
  margin-bottom: 12px;
  >*{
    margin-right:8px
  }
}
</style>
